import { Box, Typography } from '@mui/material';
import { SECTION_GRID_SPACING } from '../managedAccount.constants';

const SectionHeader = ({ children, action = null }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      mb: SECTION_GRID_SPACING,
    }}>
    <Typography variant='h6'>{children}</Typography>
    {action}
  </Box>
);

export default SectionHeader;
